<template>
    <div
        v-if="courseList.length > 0"
        ref="recommend"
        :style="{
            top: isBottom ? `${offset}px` : '100px'
        }"
        :class="{'is-fixed': isFixed}"
        class="recommend"
    >
        <span class="recommend-title">今日推荐</span>
        <div class="recommend-list">
            <div
                v-for="(course, index) in courseList"
                :key="index"
                class="recommend-list-item"
                @click="goLearnPage(course)"
            >
                <webp-image
                    :src="course.coverUrl"
                    class="recommend-cover"
                    :style="{
                        width: `${width}px`,
                        height: `${height}px`,
                    }"
                    :width="width"
                    :height="height"
                />
            </div>
        </div>
    </div>
</template>

<script>
import webpImage from '@/components/common/webpImage';
import {
    THROTTLE_TIME,
    OPEN_COURSE_TOP_DISTANCE,
    RECOMMEND_MARGIN_HEIGHT
} from '@base/constants/exercise';
// import TAOJING_SOURCE from '@/constants/sourceMap';
import {EVENT_ID_RECOMMEND_CARD_CLICK} from '@base/constants/information';
import {throttle} from 'throttle-debounce';
import urlUtils from '~/util/url';
import {mapState} from 'vuex';

export default {
    components: {
        webpImage
    },
    props: {
        courseList: {
            type: Array,
            default() {
                return [];
            }
        },
        width: {
            type: String,
            default() {
                return '290';
            }
        },
        height: {
            type: String,
            default() {
                return '161';
            }
        },
        from: {
            type: String,
            default() {
                return '';
            }
        },
        newsId: {
            type: Number,
            default() {
                return 0;
            }
        },
        contentHeight: {
            type: Number,
            default() {
                return 0;
            }
        }
    },
    data() {
        return {
            isFixed: false,
            topSpace: 100,
            // 模块高度
            clientHeight: 0,
            // 是否触底
            isBottom: false,
            // 偏移距离
            offset: 100
        };
    },
    computed: {
        ...mapState({
            sourceParams: state => state.sourceParams,
            TAOJIN_SOURCE: state => state.TAOJIN_SOURCE,
        }),
    },
    mounted() {
        const scrollTop
            = window.pageYOffset
                || document.documentElement.scrollTop
                || document.body.scrollTop;
        const defaultHeight = this.height * 3 + RECOMMEND_MARGIN_HEIGHT;
        const component = this.$refs.recommend;
        const {top} = component?.getBoundingClientRect() || {};
        this.topSpace = (top || OPEN_COURSE_TOP_DISTANCE) + scrollTop;
        this.clientHeight = component?.clientHeight || defaultHeight;
        this.throttleScroll = throttle(THROTTLE_TIME, this.handleScroll);
        window.addEventListener('scroll', this.throttleScroll, {passive: true});
    },
    destroyed() {
        window.removeEventListener('scroll', this.throttleScroll);
    },
    methods: {
        // 跳转课程详情页
        goLearnPage(payload) {
            if (this.from === 'information') {
                this.$habo.haboClickReport(EVENT_ID_RECOMMEND_CARD_CLICK, {
                    news_id: this.newsId,
                    clazz_number: payload.clazzId,
                    source: this.TAOJIN_SOURCE.INFORMATION_SLID
                });
            }
			const query = urlUtils.parseUrl(location.href);

			let calendarSource = this.TAOJIN_SOURCE.CALENDAR_SLID;
			if (this.from === 'calendar') {
				console.log('this.TAOJIN_SOURCE----', this.TAOJIN_SOURCE);
				// 498 公务员线上对应的id
				calendarSource = query?.cmsCategoryId === '498' ? this.TAOJIN_SOURCE.CALENDAR_SLID_439 : '';
				calendarSource = query?.cmsCategoryId === '500' ? this.TAOJIN_SOURCE.CALENDAR_SLID_442 : '';
			}


            let source = '';
            switch (this.from) {
                case 'information': source = this.TAOJIN_SOURCE.INFORMATION_SLID; break;
                case 'information-detail': source = this.TAOJIN_SOURCE.INFORMATION_DETAIL_SLID; break;
                case 'calendar': source = calendarSource; break;
                default: break;
            }

            this.$router.push({
                path: payload.hasSubList ? `/sublist/${pxayload.courseId}` : `/product/${payload.clazzId}`,
                query: {
                    from_leads: this.$sourceLeads,
                    signUpPathTag: source
                }
            });
        },
        // 滚动事件
        handleScroll() {
            const scrollTop
                = window.pageYOffset
                    || document.documentElement.scrollTop
                    || document.body.scrollTop;
            this.$emit('getHeight');
            if (this.contentHeight === 0) {
                this.isFixed = scrollTop + 100 > this.topSpace;
            }
            else {
                if (this.topSpace + this.clientHeight - 100 >= this.contentHeight) {
                    this.isFixed = false;
                    return;
                }
                this.isFixed = scrollTop + 100 > this.topSpace;
                this.isBottom = this.contentHeight - scrollTop <= this.clientHeight;
                this.offset = this.contentHeight - scrollTop - this.clientHeight + 100;
            }

        },
    }
};
</script>

<style lang="less" scoped>
.recommend {
    width: 100px;

    &-title {
        height: 28px;
        font-size: 18px;
        font-weight: 500;
        color: #14171c;
        line-height: 28px;
    }

    &-cover {
        border-radius: 8px;
        margin-top: 12px;
        cursor: pointer;
    }
}
.is-fixed {
    position: fixed;
    top: 100px;
}
</style>
